<template>
	<div>
		<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel" style=" display: grid;
  grid-template-columns: auto auto; grid-column-gap: 0.5rem;grid-auto-flow: row dense;">
			<el-form-item v-for="(item,index) in dialog_span" :key="index" :label="item.name" :prop="item.model">
				<el-input v-model="inputmodel[`${item.model}`]" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="人员状态" prop="status"><br>
				<el-radio v-model="inputmodel.status" :label="0">正常</el-radio>
				<el-radio v-model="inputmodel.status" :label="1">异常</el-radio>
			</el-form-item>
			<el-form-item label="所属设备" prop="device"><br>
				<el-checkbox-group v-model="device">
					<el-checkbox v-for="item in oleddevice" :label="item.name" :key="item.num"></el-checkbox>
				</el-checkbox-group>
			</el-form-item>
		</el-form>
		<div class="bottom_button">
			<el-button @click="qx(1)">取 消</el-button>
			<el-button type="primary" @click="qx()">确 定</el-button>
		</div>
	</div>
</template>

<script>
	import {
		people_edit,
		people_info
	} from "@/api/api.js"
	export default {
		data() {
			return {
				name: '',
				dialog_span: [{
					name: '编号',
					model: 'num'
				}, {
					name: '卡号',
					model: 'cardid'
				}, {
					name: '手机号',
					model: 'phone'
				}, {
					name: '姓名',
					model: 'name'
				}],
				inputmodel: {
					num: '',
					cardid: '',
					phone: '',
					name: '',
					status: ''
				},
				rules: {},
				options: [],
				device: [],
				matchedNames: [],
				card: [],
				oleddevice: []
			}
		},
		props: [
			"item"
		],
		methods: {
			qx(i) {

				if (i != 1) {
					this.$refs['inputmodel'].validate((valid) => {
						if (valid) {

							const device = []
							this.device.forEach(name => {
								// 查找 oleddevice 数组中是否存在对应的 name
								const matchedDevice = this.oleddevice.find(device => device.name === name);
								if (matchedDevice) {
									// 如果找到，将 num 添加到新数组
									device.push(matchedDevice.num);
								}
							});
							this.inputmodel.device = device
							this.inputmodel.id = `${this.inputmodel.id}`
							this.inputmodel.status = `${this.inputmodel.status}`
							delete this.inputmodel.lasttime;
							console.log(this.inputmodel);
							people_edit(this.inputmodel).then(res => {
								this.Messages(res)
								if (res.status == 200) {
									this.inputmodel = {}
									this.device = []
									this.matchedNames = []
									this.$emit('changedia', false)
									this.$parent.$parent.$parent.contractlistcontractlist();
								}
							})
						}
					})
				} else {
					// this.inputmodel = {}
					this.$emit('changedia', false)
				}
			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			},
			matchNames() {
				this.device = []
				this.matchedNames = []
				this.card.forEach(cardNum => {
					// 查找 device 数组中是否存在对应的 num
					const matchedDevice = this.oleddevice.find(device => device.num === cardNum);

					if (matchedDevice) {
						// 如果找到，将名称添加到新数组
						this.matchedNames.push(matchedDevice.name);
					}

				});
				this.device = this.matchedNames

			}
		},
		created() {
			for (let item in this.inputmodel) {
				this.rules[`${item}`] = [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}];
			}
			this.matchedNames = []
			// 深拷贝 item 到 inputmodel
			this.inputmodel = JSON.parse(JSON.stringify(this.item));

			// 异步获取数据
			people_info(this.inputmodel.id).then(res => {
				console.log(res);
				this.inputmodel = res.data.people;
				this.device = res.data.device;
				this.card = res.data.card
				this.oleddevice = res.data.device;
				this.matchNames()
			})

			if (this.item.pay_status === '正常') {
				this.inputmodel.pay_status = '0';
			} else if (this.item.pay_status === '异常') {
				this.inputmodel.pay_status = '1';
			}
		},
		watch: {
			item: function(newVal, oldVal) {
				console.log('newVal', newVal);
				this.matchedNames = []
				this.inputmodel = JSON.parse(JSON.stringify(this.item));
				// 异步获取数据
				people_info(this.inputmodel.id).then(res => {
					console.log(res);
					this.inputmodel = res.data.people;
					this.device = res.data.device;
					this.card = res.data.card
					this.oleddevice = res.data.device;
					this.matchNames()
				})

				if (this.item.pay_status === '正常') {
					this.inputmodel.pay_status = '0';
				} else if (this.item.pay_status === '异常') {
					this.inputmodel.pay_status = '1';
				}
			}
		}
	}
</script>

<style scoped>
	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}

	.upload-demo {
		display: flex;
		align-items: center !important;

	}
</style>